import * as Sentry from '@sentry/react'

const isReportingDisabled = import.meta.env.MODE === 'development'

function initSentry() {
	if (isReportingDisabled) return

	Sentry.init({
		dsn: 'https://add03ab5b3e2c5e313b8de523a6ebb09@o4509840484073472.ingest.de.sentry.io/4509840485711952',
		environment: 'production',
		// Setting this option to true will send default PII data to Sentry.
		// For example, automatic IP address collection on events
		sendDefaultPii: true,
		// Enable logs to be sent to Sentry
		enableLogs: true,
	})
}

function reportError(e: Error) {
	if (isReportingDisabled) return

	Sentry.captureException(e)
}

export const sentry = {
	init: initSentry,
	report: reportError,
	log: Sentry.logger,
}
